export default[
    {
        path: '/cirugiatv',
        name: 'cirugiaTv',
        component: () => import(/* webpackChunkName: "cirugiastv" */ '@/views/cirugia/CirugiasTv.vue'),
        meta: {
            requiresAuth: false,
            //roles:['ROLE_PACIENTES'],
        },
    }
]